<div class="label-tabs" [ngClass]="{ 'anflex-web': isAnflex }">
  <div
    *ngIf="openingState"
    class="label-tabs-search-area"
    [ngClass]="{ openned: openingState, taller: taller }"
  >
    <div class="label-tabs-field">
      <app-input-field
        label="{{ fieldLabel }}"
        [id]="'anflex-label-tab-field'"
        [uppercase]="true"
        [(ngModel)]="query"
        (keyup)="search()"
        placeholder="{{ placeholder }}"
        class="anflex-label-tab-field"
      >
      </app-input-field>
    </div>

    <div *ngIf="filteredTabs" class="label-tabs-results" [ngClass]="{ taller: taller }">
      <ng-container *ngFor="let tab of filteredTabs">
        <button
          type="button"
          tooltip="{{ getValidLabel(tab) }}"
          appDebounceClick
          (debounceClick)="selectItem(tab.id)"
          class="tab-item grid"
          [ngClass]="{
            active: tab.id === currentTab.id,
            duplicated: tab.duplicated
          }"
        >
          <ng-container *ngIf="truncate">
            {{
              getValidLabel(tab)?.length > 10
                ? (getValidLabel(tab) | slice : 0 : 7) + '...'
                : getValidLabel(tab)
            }}
          </ng-container>
          <ng-container *ngIf="!truncate">
            {{ getValidLabel(tab) }}
          </ng-container>
        </button>
      </ng-container>
    </div>
  </div>

  <div *ngIf="!openingState && tabs" class="label-tabs-items">
    <ng-container *ngIf="truncate">
      <ng-container *ngFor="let tab of currentTabList">
        <ng-container *ngIf="tab.id">
          <button
            type="button"
            tooltip="{{ getValidLabel(tab) }}"
            appDebounceClick
            (debounceClick)="selectItem(tab.id)"
            class="tab-item"
            [ngClass]="{
              active: tab.id === currentTab.id,
              duplicated: tab.duplicated
            }"
          >
            {{ getValidLabel(tab) }}
          </button>
        </ng-container>
        <ng-container *ngIf="!tab.id">
          <span
            tooltip="{{ getValidLabel(tab) }}"
            class="tab-item auto-size"
            [ngClass]="{
              active: tab.id === currentTab.id,
              duplicated: tab.duplicated
            }"
          >
            {{ getValidLabel(tab) }}
          </span>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!truncate">
      <ng-container *ngFor="let tab of currentTabList">
        <ng-container *ngIf="tab.id">
          <button
            type="button"
            appDebounceClick
            (debounceClick)="selectItem(tab.id)"
            class="tab-item auto-size"
            [ngClass]="{
              active: tab.id === currentTab.id,
              duplicated: tab.duplicated
            }"
          >
            {{ getValidLabel(tab) }}
          </button>
        </ng-container>
        <ng-container *ngIf="!tab.id">
          <span
            class="tab-item auto-size"
            [ngClass]="{
              active: tab.id === currentTab.id,
              duplicated: tab.duplicated
            }"
          >
            {{ getValidLabel(tab) }}
          </span>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="searchable">
    <button
      *ngIf="!openingState"
      type="button"
      class="btn-clear"
      [ngClass]="{ open: openingState }"
      (click)="open()"
    >
      <i class="fas fa-chevron-down"></i>
    </button>
    <button
      *ngIf="openingState"
      type="button"
      class="btn-clear"
      [ngClass]="{ open: openingState }"
      (click)="close()"
    >
      <i class="fas fa-chevron-up"></i>
    </button>
  </ng-container>
</div>
